import React from 'react';
import { useLocation } from 'react-router-dom';
import { AuthBadge } from '../../features/auth';
import { NotificationBell } from '../../features/notifications/NotificationBell';

const pageTitles: Record<string, string> = {
  '/': '仪表盘',
  '/positions': '持仓管理',
  '/history': '历史记录',
  '/settings': '设置',
};

function getPageTitle(pathname: string): string {
  // Exact match
  if (pageTitles[pathname]) {
    return pageTitles[pathname];
  }
  
  // Position detail pages
  if (pathname.match(/^\/positions\/\d+$/)) {
    return '持仓详情';
  }
  if (pathname.match(/^\/positions\/\d+\/decision\/monthly$/)) {
    return '月度决策';
  }
  if (pathname.match(/^\/positions\/\d+\/decision\/weekly$/)) {
    return '周度校验';
  }
  if (pathname.match(/^\/positions\/\d+\/decision\/daily$/)) {
    return '日度执行';
  }
  if (pathname.match(/^\/positions\/\d+\/trades$/)) {
    return '交易历史';
  }
  
  return '纪律投资';
}

export function TopBar() {
  const location = useLocation();
  const title = getPageTitle(location.pathname);

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center justify-between border-b bg-background/95 px-6 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <h1 className="font-display text-xl font-semibold">{title}</h1>
      
      <div className="flex items-center gap-3">
        <NotificationBell />
        <div className="h-6 w-px bg-border" />
        <AuthBadge />
      </div>
    </header>
  );
}
